import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  width: 100%;
  margin: 0 0 10px 25px;
`;

export default Wrap;
